module.exports = __webpack_public_path__ + "img/why-championla_image3.f57217d5.jpg";